import React from 'react';
import ChatTextSamplesModalContents from './ChatTextSamplesModalContents';
import BaseTextSampleModalContents from './BaseTextSampleModalContents';
import CallTextSampleModalContents from './CallTextSampleModalContents';
import EmailTextSamplesModalContents from './EmailTextSamplesModalContents';
import FeedbackTextSamplesModalContents from './FeedbackTextSamplesModalContents';
import {AnyBaseEvent, EventTextField, EventTypeName} from 'entities/event';

interface Props {
    eventData: AnyBaseEvent;
    fieldToShow: EventTextField;
    autoScrollScope?: 'event' | 'search' | 'textSamples';
}

const modalContentsComponents: Partial<Record<EventTypeName, React.FC<Props>>> = {
    [EventTypeName.Call]: CallTextSampleModalContents,
    [EventTypeName.Chat]: ChatTextSamplesModalContents,
    [EventTypeName.Email]: EmailTextSamplesModalContents,
    [EventTypeName.Feedback]: FeedbackTextSamplesModalContents,
};


export const TextSamplesModalContentsWrapper = React.memo<Props>(
    ({eventData, fieldToShow, autoScrollScope = 'textSamples'}) => {
        let Component: React.FC<Props> = BaseTextSampleModalContents;
        if (Object.prototype.hasOwnProperty.call(modalContentsComponents, eventData.event_type_name)) {
            Component = modalContentsComponents[eventData.event_type_name]!;
        }

        if (eventData.event_type_name === EventTypeName.Call) {
            return (
                <CallTextSampleModalContents
                    eventData={eventData as any}
                    fieldToShow={fieldToShow}
                    autoScrollScope={autoScrollScope}
                />
            );
        }

        return (
            <Component
                eventData={eventData}
                fieldToShow={fieldToShow}
            />
        );
    },
);
